import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Grid, useMediaQuery, useTheme } from "@mui/material"
import ITEMS from "./footer-items.json"
import LINKEDIN from "../../assets/icons/linkedin.svg"
import FACEBOOK from "../../assets/icons/facebook.svg"
import TWITTER from "../../assets/icons/twitter.svg"
import INSTAGRAM from "../../assets/icons/instagram.svg"
import FooterLogo from "../../assets/icons/copia-footer-logo.svg"

import * as S from "./footer.styles"

const Footer = ({ className }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const staticQuery = useStaticQuery(graphql`
    query {
      copiaLogo: file(relativePath: { eq: "footer-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        }
      }
    }
  `)
  return (
    <S.FooterSection className={className}>
      <S.Wrapper maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={7}>
            {/* <S.Image img={staticQuery?.copiaLogo} /> */}
            <FooterLogo />
            <S.Description>
              Copia is the leading technology-enabled surplus recovery service,
              empowering businesses to easily distribute their surplus. National
              brands across the US work with Copia to reduce food insecurity in
              the communities where they operate, help reduce their greenhouse
              gas emissions, and boost their profitability.
            </S.Description>
          </Grid>
          <Grid item xs={6} md={1.5} lg={1.5}>
            <S.Title>COMPANY</S.Title>
            <S.LinksContainer>
              {ITEMS?.mainItems?.map(({ name, link }, index) => (
                <S.Link url={link} key={`${name}-${index}`} className="item">
                  {name}
                </S.Link>
              ))}
            </S.LinksContainer>
          </Grid>
          <Grid item xs={6} md={1.5} lg={1.5}>
            <S.Title>MORE</S.Title>
            <S.LinksContainer>
              {ITEMS?.otherItems?.map(({ name, link }, index) => (
                <S.Link url={link} key={`${name}-${index}`} className="item">
                  {name}
                </S.Link>
              ))}
            </S.LinksContainer>
          </Grid>
          <Grid item xs={12} md={3} lg={2}>
            <S.Title className="social">LET'S GET SOCIAL</S.Title>
            <S.SocialContainer>
              <S.SocialButton
                href="https://www.linkedin.com/company/gocopia"
                target="_blank"
              >
                <LINKEDIN />
              </S.SocialButton>
              <S.SocialButton
                href="https://www.facebook.com/GoCopia"
                target="_blank"
              >
                <FACEBOOK />
              </S.SocialButton>
              <S.SocialButton
                href="https://twitter.com/gocopia"
                target="_blank"
              >
                <TWITTER />
              </S.SocialButton>
              <S.SocialButton
                href="https://www.instagram.com/gocopia/"
                target="_blank"
              >
                <INSTAGRAM />
              </S.SocialButton>
            </S.SocialContainer>
          </Grid>
        </Grid>
        <S.BottomContainer>
          <S.Link url="/privacy-policy">Privacy Policy</S.Link>
          <S.Link url="/legal">Terms and Conditions</S.Link>
          {!isMobile && (
            <S.Copyright>
              © Copia {new Date().getFullYear()}. All rights reserved
            </S.Copyright>
          )}
        </S.BottomContainer>
        {isMobile && (
          <S.Copyright>
            © Copia {new Date().getFullYear()}. All rights reserved
          </S.Copyright>
        )}
      </S.Wrapper>
    </S.FooterSection>
  )
}

export default Footer
